import React from 'react';
import PropTypes from 'prop-types';

export default class LocationBadge extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="idling-badge">
                {this.props.loc}
            </div>
        )
    }
}

LocationBadge.propTypes = {
    loc: PropTypes.string,
};
